import React from 'react'
import { Image } from 'react-native'
import { XStack, YStack, useMedia } from 'tamagui'
import { CardTitle } from '@/components/ui/Typography'
import { Collection } from '../../types'

interface CollectionCardProps extends Collection {
  onPress?: () => void
}

export const CollectionCard: React.FC<CollectionCardProps> = ({
  id,
  collectionTitle,
  imageUrl,
  bgColor,
  onPress,
}) => {
  const media = useMedia()
  const isMobile = !media.gtSm
  const cardWidth = media.gtMd ? 267 : media.gtSm ? 229 : 180
  const imageSize = media.gtMd ? 100 : media.gtSm ? 86 : 72

  return (
    <YStack
      w={cardWidth}
      h={imageSize}
      br={8}
      overflow="hidden"
      backgroundColor={bgColor || '#F4EFFF'}
      style={{ cursor: 'pointer' }}
      hoverStyle={{ scale: 1.03, shadowColor: '#000', shadowOpacity: 0.2, shadowRadius: 10 }}
      pressStyle={{ scale: 0.98, opacity: 0.9 }}
      animation="bouncy"
      onPress={onPress}
    >
      <XStack w="100%" h="100%" ai="center" gap={isMobile ? 10 : 12}>
        <Image
          source={{ uri: imageUrl }}
          style={{
            width: imageSize,
            height: imageSize,
            borderRadius: 12,
            resizeMode: 'cover',
          }}
        />
        <YStack
          f={1}
          minWidth={0}
          h="100%"
          jc="center"
          pr={14}
          py={isMobile ? 8 : 10}
        >
          <CardTitle
            flexShrink={1}
            color="$color12"
            numberOfLines={3}
          >
            {collectionTitle}
          </CardTitle>
        </YStack>
      </XStack>
    </YStack>
  )
}
